module.exports = __webpack_public_path__ + "img/cbre-logo-green.f3f084c0.svg";